import React from "react";
import { UserProps } from "Data/user";
import styled from "styled-components";
import Avatar from "Components/Avatar";
import TextParagraph from "Components/Text/TextParagraph";
import Title, { TitleType } from "Components/Text/Title";
import LinkWithIcon from "Components/LinkWithIcon";
import media from "Styles/media";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-items: center;
	align-items: center;
	text-align: center;
`;
const Name = styled(Title)`
	padding-top: 16px;
	padding-bottom: 10px;
`;
const Bio = styled(TextParagraph)`
	max-width: 600px;
`;

const LinkWrapper = styled.div`
	margin-top: 16px;
	display: flex;
	justify-content: center;
	@media ${media.mobile} {
		justify-content: space-around;
	}
`;

const DetailUser: React.FC<{ user: UserProps }> = ({ user }) => {
	return (
		<Wrapper>
			<Avatar image={user.image} />
			<Name type={TitleType.SM} value={user.name} />
			<Bio value={user.bio} />
			{user.link && (
				<LinkWrapper>
					{user.link.map((el, index) => {
						return (el.url != "") && <LinkWithIcon key={index} data={el}></LinkWithIcon>;
					})}
				</LinkWrapper>
			)}
		</Wrapper>
	);
};

export default DetailUser;
